"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCORDION_SUMMARY = exports.ACCORDION = void 0;
const ACCORDION = exports.ACCORDION = 'accordion';
const ACCORDION_SUMMARY = exports.ACCORDION_SUMMARY = 'accordion-summary';
//# sourceMappingURL=constants.js.map